import React, { createContext, useContext, useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import LegalPage from "@/pages/LegalPage";
import ServicePage from "@/pages/ServicePage";
import { translations } from "@/lib/content";

const LangContext = createContext({ lang: "en", setLang: () => {}, t: translations.en });

export const useLang = () => useContext(LangContext);

function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("neurotheos_lang") || ((navigator.language || "").toLowerCase().startsWith("ro") ? "ro" : "en"));
  useEffect(() => { localStorage.setItem("neurotheos_lang", lang); }, [lang]);
  const value = { lang, setLang, t: translations[lang] };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home forceLang="ro" />} />
          <Route path="/en" element={<Home forceLang="en" />} />
          <Route path="/psiholog-roman-online-diaspora" element={<ServicePage pageKey="diaspora" lang="ro" />} />
          <Route path="/en/romanian-psychologist-abroad" element={<ServicePage pageKey="diaspora" lang="en" />} />
          <Route path="/psiholog-anxietate-stres" element={<ServicePage pageKey="anxiety" lang="ro" />} />
          <Route path="/en/anxiety-stress-therapy" element={<ServicePage pageKey="anxiety" lang="en" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
